import { render, staticRenderFns } from "./rails_landscape.vue?vue&type=template&id=4edadf20&scoped=true&"
import script from "./rails_landscape.vue?vue&type=script&lang=js&"
export * from "./rails_landscape.vue?vue&type=script&lang=js&"
import style0 from "./rails_landscape.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rails_landscape.vue?vue&type=style&index=1&id=4edadf20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edadf20",
  null
  
)

export default component.exports